import { AccountFeatures, AppContext } from '@lightspeed-invoicing/core-client/frontend';
import React, { Component } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import GlobalHelper from "../common/GlobalHelper.jsx";
import Icon from "../common/icon/icon.component.jsx";
import SideBar from '../common/layout/sidebar.component.jsx';
import MyAccountTabs from "../common/layout/tabs/myaccount.component.jsx";
import StandardList from '../common/listing/list.component.jsx';
import ButtonWrapper from '../common/rich-text/feature-protection-wrappers/buttonProtectionWrapper.component';
import LoadingSpinner from '../common/spinner/loading.component.jsx';

class LocationListing extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            rows: [],
            headers: [],
            searchKeywords: '',
            loading: false,
            isProSubscriptionType: false,
            enabledLocations: [],
        }
        this.handleSearchChange = this.handleSearchChange.bind(this)
        this.enableLocation = this.enableLocation.bind(this)
        this.enableLocationButtonShow = this.enableLocationButtonShow.bind(this)
    }

    componentDidMount() {
        SideBar.activateMenu('account')
        this.refreshSearch()
    }

    handleSearchChange(event) {
        const target = event.target;
        this.setState({
            searchKeywords: target.value
        }, () => {
            this.refreshSearch()
        })
    }

    refreshSearch() {
        this.setState({
            loading: true,
        })
        AppContext.getApiClient().get('/locations').then(r => {
            this.setState({
                enabledLocations: r.data.filter(loc => loc.attributes.enabled),
            }, () => {
                this.setState({
                    headers: r.data.length > 0 ? this.headers() : [],
                    rows: r.data.map(q => this.row(q)),
                    loading: false,
                })
            })
        })

    }

    enableLocation(event, location, enabled) {
        AppContext.getApiClient().patch('/locations/' + location.id, { enabled }).then(loc => {
            this.refreshSearch()
        })
    }

    headers() {
        return [
            <FormattedMessage
                id="listing.location.list.headers.name_label"
                defaultMessage="Name"
            />,
            <FormattedMessage
                id="listing.user.list.headers.city_label"
                defaultMessage="City"
            />,
            <FormattedMessage
                id="listing.user.list.headers.created_at_label"
                defaultMessage="Created at"
            />,

            <FormattedMessage
                id="listing.locations.list.headers.enable_locations_label"
                defaultMessage="Enable Locations"
            />,
            <FormattedMessage
                id="listing.user.list.headers.enabled_label"
                defaultMessage="Enabled"
            />
        ]
    }

    enableLocationButtonShow() {
        var featureEnabled = AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureMultiLocation)
        var validNumberOfLocations = (this.state.enabledLocations.length < AppContext.getAccount().attributes.maxNumberOfLocations ||
            AppContext.getAccount().attributes.maxNumberOfLocations === 0)

        return featureEnabled && validNumberOfLocations
    }

    row(item) {
        const contact = item.attributes.organization.attributes.address
        const address = {
            city: contact.city,
            stateCode: contact.stateCode,
            state: contact.state,
            country: contact.country,
            countryCode: contact.countryCode,
        }
        const city = GlobalHelper.formatCityFromAddress(address, AppContext.getLocale().getLanguageWithoutRegionCode())
        return [
            <Link to={"/locations/" + item.id + '/edit'}>{item.attributes.name}</Link>,
            city ? city : '-',
            <FormattedDate
                year='numeric'
                month='long'
                day='numeric'
                value={new Date(item.attributes.createdAt)} />,
            !item.attributes.enabled ?
                <ButtonWrapper
                    message={this.state.enabledLocations.length > 0 ?
                        <FormattedMessage
                            id="listing.locations.list.headers.update_plan_message"
                            defaultMessage="Update your plan to increase the number of enabled locations."
                        /> : ''}
                    isProtected={this.state.enabledLocations.length > 0}
                    onClick={(e) => this.enableLocation(e, item, true)}
                    accountFeatureKey={AccountFeatures.FeatureMultiLocation}
                    className={'btn btn-sm btn-outline-primary'}
                    protectedClassName={'btn btn-sm btn-outline-primary'}
                    protectionRule={this.enableLocationButtonShow()}>
                    <span>
                        <FormattedMessage
                            id="listing.user.list.locations.enable_btn_label"
                            defaultMessage="Enable location"
                        />
                    </span>
                </ButtonWrapper>
                : <button className={'btn btn-sm btn-outline-secondary'}
                    onClick={(e) => this.enableLocation(e, item, false)}>
                    <FormattedMessage
                        id="listing.user.list.locations.disable_btn_label"
                        defaultMessage="Disable location"
                    />
                </button>,
            item.attributes.enabled ?
                <span className="badge badge-success">
                    <FormattedMessage
                        id="listing.user.list.headers.enabled_label"
                        defaultMessage="Enabled"
                    />
                </span> :
                <span className="badge badge-secondary">
                    <FormattedMessage
                        id="listing.user.list.headers.disabled_label"
                        defaultMessage="Disabled"
                    />
                </span>
        ]
    }

    render() {
        let list = <StandardList
            className="row pt-3"
            headers={this.state.headers}
            rows={this.state.rows}
        />
        if (this.state.loading) {
            list = <LoadingSpinner />
        }

        return (
            <div>
                <MyAccountTabs />
                <div className="row ui-has-modules py-1">
                    <div className="col-12 ui-module mb-0">
                        <div className="row mb-0 justify-content-end">
                            <div className="col-3 text-align-right ">
                                <Link to="/locations/new" className="btn btn-primary">
                                    <Icon value={"plus-circle"} />
                                    <FormattedMessage
                                        id="location.listing.add_user_btn"
                                        defaultMessage="Add location"
                                    />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                {list}
            </div>
        );
    }
}

export default LocationListing


// WEBPACK FOOTER //
// ./src/location/listing.component.jsx